<!-- Layout with two columns used for nested pages such as lidContactpersoon, lidGebruikersgroep etc. -->
<template>
    <v-app id="inspire">
        <Header />
        <v-main class="grey lighten-3">
            <v-container fluid class="pt-0">
                <!-- row for breadcrumbs on top of page that can be navigated -->
                <v-row>
                    <!-- empty spot so breadcrumbs are above second column -->
                    <v-col cols="12" sm="2"> </v-col>
                    <v-col cols="12" sm="10">
                        <div class="breadcrumb">
                            <ul>
                                <li
                                    v-for="(breadcrumb, index) in crumbs"
                                    :key="index"
                                    @click="goTo(breadcrumb.link)"
                                    :class="{ linked: breadcrumb.link }"
                                >
                                    {{ breadcrumb.name }}
                                </li>
                            </ul>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- Left column that shows the current member and possible subpages-->
                    <v-col cols="12" sm="2">
                        <v-sheet rounded="lg" min-height="268">
                            <v-navigation-drawer permanent floating>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ breadcrumbName }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list dense nav>
                                    <v-list-item
                                        v-for="item in items"
                                        :key="item.title"
                                        @click="goTo(item.to)"
                                        link
                                    >
                                        <v-list-item-icon>
                                            <v-icon>{{ item.icon }}</v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                item.title
                                            }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-group
                                        v-if="selectedUsergroup"
                                        sub-group
                                        disabled
                                        value="true"
                                        prepend-icon=""
                                        class="nopointer"
                                    >
                                        <template v-slot:activator>

                                            <v-list-item-content>
                                                <v-list-item-title
                                                    style="
                                                        text-align: left;
                                                        padding-left: 20px;
                                                        color: black;
                                                        font-weight:800;
                                                        padding-bottom: 6px;
                                                        font-size:16px;"
                                                    >{{gebruikersgroep.VersionUserGroup[0].name}}</v-list-item-title
                                                >
                                            </v-list-item-content>
                                        </template>
                                        <v-list-item
                                            class="autopointer"
                                            @click="goTo('lidgebruikersgroepfunctionaliteiten')"
                                        >
                                            <v-list-item-icon>
                                                <v-icon>mdi-apps-box</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    >Functionaliteitautorisaties</v-list-item-title
                                                >
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item
                                            class="autopointer"
                                            @click="goTo('lidgebruikersgroep')"
                                        >
                                            <v-list-item-icon>
                                                <v-icon
                                                    >mdi-account-multiple</v-icon
                                                >
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    >Gebruikers</v-list-item-title
                                                >
                                            </v-list-item-content>
                                        </v-list-item>


                                    </v-list-group>
                                </v-list>
                            </v-navigation-drawer>
                        </v-sheet>
                    </v-col>
                    <!-- Right column that shows the data of the current page-->
                    <v-col cols="12" sm="10">
                        <v-sheet
                            min-height="calc(100vh - 160px)"
                            min-width="100%"
                            rounded="lg"
                        >
                            <router-view />
                            <div class="pb-2 d-flex border-top">
                                <v-spacer></v-spacer>
                                <span class="grey--text"
                                    >Laatst opgehaald op:</span
                                >
                                <span class="mx-2 grey--text">{{
                                    new Date().toLocaleString("nl-NL")
                                }}</span>
                            </div>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import Header from "@/components/Header";
//import keycloakConstants from "./constants/keycloakConstants.js";
import {keycloakMixin} from  "@/mixins/";
import keycloakConstants from '../constants/keycloakConstants';

export default {
    components: {
        Header,
    },
    mixins: [
    keycloakMixin
  ],
    data() {
        let items = [];

        return {
            //Items show on the left column for navigation
            items: items,
            breadcrumbName: "Lidnaam",
            lid: {
                name: "Lidnaam",
            },
            gebruikersgroep: {
                VersionUserGroup: [{ name: "Groepnaam" }],
            },
            //Will be filled with all the breadcrumbs
            breadcrumbList: [],
            //Fields in the breadcrumbs that contain an ID number used in computed crumbs
            breadcrumbIdFields: [
                "StaticOrganisatieID",
                "StaticGebruikersgroepID",
            ],
            selectedUsergroup: false
        };
    },
    mounted() {
        this.updateList();
        this.setEmpoweredRoles();
    },
    methods: {
        goTo(pathName) {
            if (!pathName || this.$route.name === pathName) {
                return;
            }

            this.$router.push({
                name: pathName,
                params: { id: this.$route.params.staticId },
            });
            this.setEmpoweredRoles();

        },

        async updateList() {
            this.selectedUsergroup = false;
            this.breadcrumbList = this.$route.meta.breadcrumb;
            if (this.$route.params.applicationId) {
                const { Application } = await import("@/api/data");
                this.application = Object.assign(
                    {},
                    await Application.getOne(this.$route.params.applicationId)
                );
                this.breadcrumbName = this.application.name;
            }
            if (this.$route.params.staticId) {
                const { Leden } = await import("@/api/data");
                this.lid = Object.assign(
                    {},
                    await Leden.getOne(this.$route.params.staticId)
                );
                this.breadcrumbName = this.lid.name;
            }
            if (this.$route.params.staticGebruikersgroepId) {
                this.selectedUsergroup = true;
                const { Gebruikersgroep } = await import("@/api/data");
                this.gebruikersgroep = Object.assign(
                    {},
                    await Gebruikersgroep.getOne(
                        this.$route.params.staticGebruikersgroepId
                    )
                );
            }
        },

        async setEmpoweredRoles() {
            /**
             * If user is HDN_ADMIN, set all empoweredRoles
             * If user is ORG_ADMIN && org is own organisation, set all empoweredRoles
             * if user is one of specific roles && org is own organisation, set specific empoweredRoles
             * Else GET empoweredRoles to only show allowed side tabs. Tab 'Machtigingen' is filtered
             */

            let empoweredRoles = [];

            if(this.isHDNAdmin() || this.isHDNInzage()) {
                empoweredRoles = [
                    keycloakConstants.CONTACTPERSONEN_ADMIN,
                    keycloakConstants.AUTORISATIE_ADMIN,
                    keycloakConstants.MACHTIGINGEN_ADMIN,
                ];
            }
            else if (parseInt(this.$route.params.staticId) === await this.getMemberId() && this.isORGAdmin()) {
                empoweredRoles = [
                    keycloakConstants.CONTACTPERSONEN_ADMIN,
                    keycloakConstants.AUTORISATIE_ADMIN,
                    keycloakConstants.MACHTIGINGEN_ADMIN,
                ];
            }
            else if (parseInt(this.$route.params.staticId) === await this.getMemberId()) {
                if(this.isContactpersonenBeheerder()) {
                    empoweredRoles.push(keycloakConstants.CONTACTPERSONEN_ADMIN);
                }
                if(this.isAutorisatieBeheerder()) {
                    empoweredRoles.push(keycloakConstants.AUTORISATIE_ADMIN);
                }
                if(this.isMachtigingenBeheerder()) {
                    empoweredRoles.push(keycloakConstants.MACHTIGINGEN_ADMIN);
                }
            } else {
                empoweredRoles = this.getEmpoweredRoles();
            }

            if(this.isFacturatieGegevensInzageUser()) {
                empoweredRoles.push(keycloakConstants.FACTURATIE_GEGEVENS_INZAGE);
            }
            if(this.isFacturatieGegevensBeheerder()) {
                empoweredRoles.push(keycloakConstants.FACTURATIE_GEGEVENS_BEHEER);
            }
            let items = [];
            if (window.location.pathname.includes("/usermanagement/applicaties/")) {
                items.push({
                    to: "applicatiegegevens",
                    title: "Gegevens",
                    icon: "mdi-information-outline",
                });
                items.push({
                    to: "functionaliteitautorisaties",
                    title: "Functionaliteitautorisaties",
                    icon: "mdi-apps",
                });
                items.push({
                    to: "authenticatiemethoden",
                    title: "Authenticatiemethoden",
                    icon: "mdi-shield-account",
                });

            } else {
                items.push({
                    to: "lidgegevens",
                    title: "Gegevens",
                    icon: "mdi-information-outline"
                });

                if (empoweredRoles.includes(keycloakConstants.AUTORISATIE_ADMIN)) {
                    items.push({
                        to: "lidfunctionaliteitautorisaties",
                        title: "Functionaliteitautorisaties",
                        icon: "mdi-apps",
                    });
                }
                if (empoweredRoles.includes(keycloakConstants.CONTACTPERSONEN_ADMIN)) {
                    items.push({
                        to: "lidcontactopties",
                        title: "Contactopties",
                        icon: "mdi-bell-cog-outline"
                    });
                    items.push({
                        to: "lidcontactpersonen",
                        title: "Contactpersonen",
                        icon: "mdi-book-open-blank-variant",
                    });
                }
                if (empoweredRoles.includes(keycloakConstants.MACHTIGINGEN_ADMIN)){
                    items.push({
                        to: "lidmachtigingen",
                        title: "Machtigingen",
                        icon: "mdi-account-lock",
                    });
                }
                if (empoweredRoles.includes(keycloakConstants.AUTORISATIE_ADMIN)) {
                    items.push({
                        to: "lidgebruikersgroepen",
                        title: "Gebruikersgroepen",
                        icon: "mdi-account-group",
                    });
                }
                if (empoweredRoles.includes(keycloakConstants.FACTURATIE_GEGEVENS_INZAGE) || empoweredRoles.includes(keycloakConstants.FACTURATIE_GEGEVENS_BEHEER)) {
                    items.push({
                        to: "facturatie-instellingen",
                        title: "Facturatie-instellingen",
                        icon: "mdi-credit-card",
                    });
                }
            }
            this.items = items;
        },

        getEmpoweredRoles() {
            let empoweredRoles = localStorage.getItem('empoweredRoles');
            let empoweredRolesParsed = JSON.parse(empoweredRoles);

            let results = [];

            for (const empoweredRole of empoweredRolesParsed.value) {
                if (empoweredRole.StaticFunctionalityMember.StaticFunctionality.StaticApplication.name === 'usermanagement' && empoweredRole.StaticFunctionalityMember.memberId === parseInt(this.$route.params.staticId)) {
                    results.push(empoweredRole.StaticFunctionalityMember.StaticFunctionality.name);
                }
            }

            return results;
        },
    },
    computed: {
        /**
         * Function that swaps placeholder tags like StaticOrganisatieID for the current route path
         * This makes it so it shows Organisaties/1 instead of Organisaties/StaticOrganisatieID
         */
        crumbs: function () {
            //Create a copy so we don't change the route meta permenantly
            let breadcrumbCopy = JSON.parse(
                JSON.stringify(this.$route.meta.breadcrumb)
            );

            /**
             * We iterate over the breadcrumbs to check if the key 'value' is defined.
             * This key is defined in order to replace breadcrumbIdFields with the proper value.
             * The 'value' key is set in routes.js. This is done because the this.$route.params is
             * not available in routes.js.
             */
            breadcrumbCopy.forEach((breadcrumb) => {
                if (breadcrumb.value) {
                    if ( breadcrumb.value === "lid.name" || breadcrumb.value === "application.name" ) {
                        breadcrumb.name = this.breadcrumbName;
                    }
                    else if (breadcrumb.value === "gebruikersgroep.VersionUserGroup[0].name") 
                    {
                        if (this?.gebruikersgroep?.VersionUserGroup?.[0]?.name) {
                            breadcrumb.name = this.gebruikersgroep.VersionUserGroup[0].name;
                        }
                    }
                    else {
                        breadcrumb.name = this.$route.params[breadcrumb.value];
                    }
                }
            });

            return breadcrumbCopy;
        },
    },
    watch: {
        $route() {
            this.updateList();
        },
    },
};
</script>

<style lang="scss" scoped>
.border-top {
    border-top: thin solid rgba(0, 0, 0, 0.12);
}
.breadcrumb {
    float: left;
}
ul {
    display: flex;
    justify-content: center;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
ul > li {
    display: flex;
    float: left;
    height: 10px;
    width: auto;
    color: default;
    font-weight: bold;
    font-size: 0.8em;
    cursor: default;
    align-items: center;
}
ul > li:not(:last-child)::after {
    content: "/";
    float: right;
    font-size: 0.8em;
    margin: 0 0.5em;
    color: light-default;
    cursor: default;
}
.linked {
    cursor: pointer;
    font-size: 1em;
    font-weight: normal;
}
.v-list-item__title {
    text-align: left;
    padding-left: 5px;
}
//CSS for list-item topgroups/parents
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 10px;
    margin-left: 5px;
}
//CSS for list-item subgroup/childs
.v-application--is-ltr
    .v-list-group--sub-group
    .v-list-item__action:first-child,
.v-application--is-ltr
    .v-list-group--sub-group
    .v-list-item__avatar:first-child,
.v-application--is-ltr .v-list-group--sub-group .v-list-item__icon:first-child {
    margin-right: 10px;
    margin-left: 0;
}

.nopointer{
    pointer-events: none;
}

.autopointer{
    pointer-events: auto;
}

.v-list-group--sub-group{
    display: block;
}
</style>